<template>
    <div
        v-click-outside="hide"
        class="md:relative"
    >
        <span
            v-if="unreadCount > 0"
            class="notification-count-pill"
            @click="toggleVisibility"
        >
            {{ unreadCount }}
        </span>
        <span
            ref="button"
            class="relative fa-2x cursor-pointer"
            @click="toggleVisibility"
        >
            <div
                class="flex"
                :class="{ 'swing animated infinite': newNotificationArrived }"
            >
                <font-awesome-icon
                    icon="bell"
                    class="text-lg"
                    :class="{ 'text-neutral-dark': layout === 'dark', 'text-white': layout === 'light' }"
                />
            </div>
        </span>
        <div
            v-show="showNotifications"
            ref="dropdown"
            class="notifications py-md px-sm flex flex-col text-sm"
        >
            <button
                v-if="hasNotifications"
                type="button"
                class="ml-auto my-sm text-link mr-md"
                @click="markAllAsRead"
            >
                Markera alla som lästa
            </button>

            <div v-if="! hasNotifications" class="p-md text-center">
                Du har inte fått några notiser ännu!
            </div>
            <ul v-else class="notifications-list mb-sm">
                <li
                    v-for="notification in notifications"
                >
                    <a :href="notification.data.link" class="notifications-list-item group">
                        <div class="notification-unread-pill-wrapper">
                            <div
                                v-if="notification.read_at === null"
                                class="notification-unread-pill"
                            />
                        </div>
                        <div
                            class="truncate text-left flex-1 pl-md text-neutral-dark py-md"
                            style="width: 61%;"
                            :title="notification.data.title"
                            :class="{ 'font-semibold text-black': notification.read_at === null }"
                        >
                            {{ notification.data.title }}
                            <!-- eslint-disable vue/no-v-html -->
                            <div class="notification-body" v-html="notification.data.body" />
                        </div>
                        <div class="group-hover:hidden text-neutral-dark-light py-md pr-md">
                            {{ notificationAge(notification) }}
                        </div>
                        <a
                            v-if="notification.read_at === null"
                            href="#"
                            class="hidden group-hover:block text-link py-md pr-md"
                            @click="markAsRead(notification)"
                        >
                            Markera som läst
                        </a>
                        <a
                            v-else
                            href="#"
                            class="hidden group-hover:block text-link py-md pr-md"
                            @click="markAsUnread(notification)"
                        >
                            Markera som oläst
                        </a>
                    </a>
                </li>
            </ul>
            <button
                v-if="nextPageUrl"
                class="w-full text-neutral-dark-light py-sm text-white"
                @click="loadMore"
            >
                Ladda fler notiser
            </button>
        </div>
    </div>
</template>

<script>
    import ClickOutside from 'vue-click-outside';
    import Popper from 'popper.js';
    import { distanceInWordsToNow } from 'date-fns';
    import * as svLocale from 'date-fns/locale/sv/index';

    export default {
        directives: {
            ClickOutside,
        },
        props: {
            layout: {
                required: false,
                type: String,
                default: 'dark',
            },
        },
        data() {
            return {
                notifications: [],
                showNotifications: false,
                newNotificationArrived: false,
                nextPageUrl: null,
                unreadCount: 0,
            };
        },
        computed: {
            hasNotifications() {
                return this.notifications.length > 0;
            },
        },
        watch: {
            notifications: {
                handler: function () {
                    this.fetchTotalUnread();
                },
                deep: true,
            },
        },
        mounted() {
            this.fetchNotifications();
        },
        methods: {
            fetchTotalUnread() {
                axios.get(route('api.notifications.unreadCount'))
                    .then((response) => {
                        this.unreadCount = response.data.unread_count;
                    });
            },
            fetchNotifications() {
                axios.get(route('api.notifications.index')).then((response) => {
                    this.notifications = response.data.data;
                    this.nextPageUrl = response.data.next_page_url;
                });
            },
            toggleVisibility() {
                this.showNotifications = ! this.showNotifications;

                this.$nextTick(() => {
                    new Popper(this.$refs.button, this.$refs.dropdown, {
                        placement: 'bottom',
                    });
                });
            },
            markAllAsRead() {
                axios.patch(route('api.notifications.allRead'))
                    .then(() => {
                        this.fetchNotifications();
                    });
            },
            markAsRead(notification) {
                axios.patch(route('api.notifications.read', { notification: notification.id }))
                    .then((response) => {
                        notification.read_at = response.data.read_at;
                    });
            },
            markAsUnread(notification) {
                axios.patch(route('api.notifications.unread', { notification: notification.id }))
                    .then(() => {
                        notification.read_at = null;
                    });
            },
            hide() {
                this.showNotifications = false;
            },
            notificationAge(notification) {
                return distanceInWordsToNow(notification.created_at, {
                    addSuffix: true,
                    locale: svLocale,
                });
            },
            loadMore() {
                if (this.nextPageUrl) {
                    axios.get(this.nextPageUrl)
                        .then((response) => {
                            response.data.data.forEach((notification) => {
                                this.notifications.push(notification);
                            });

                            this.nextPageUrl = response.data.next_page_url;
                        });
                }
            },
        },
    };
</script>